// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"45029eb9","315":"c5884624","360":"6181d482","381":"1eb869d0","824":"421a4cd6","900":"f7c672f6","961":"4110a454"}[chunkId] + ".chunk.css";
};